fx.ns("repositories", class TextsRepository extends fx.ModelArray {

    constructor()
    {
        super([]);

        this._cache = {};
        this.endpoint = "/app/texts";
        
        this._loadedRecommandedHandler = this._loadedRecommended.bind(this);
    }

    get requestDefaultParams()
	{
		return {connectionid : fx.get("connectionid")};
	}

    find(obj, model)
    {
        if (obj.id == "text")
        {
            return {    content : '', 
                        content_type : "text", 
                        align: model.creation.last_align ? model.creation.last_align : "left",
                        text_color: model.customcolors ? model.customcolors.lastColor : "#000",
                        font_family : model.creation.last_font_family ? model.creation.last_font_family : 1,
                        font_size : 6,
                        text_width:180, 
                        text_height:100
                    };
        }
        else
        if (obj.id == "title")
        {
            return {    content : '', 
                        content_type : "title", 
                        align:"center", 
                        text_color: model.customcolors ? model.customcolors.lastColor : "#000", 
                        font_family : model.creation.last_font_family ? model.creation.last_font_family : 1,
                        font_size : 18, 
                        text_width:180, 
                        text_height:35};
        }
        else
            return super.find(obj);

    }


    load( tag_id )
    {
        if (this._cache[tag_id])
            return;

        this.post(  { 
            action:"load", 
            tag_id : tag_id
        }, 
        this._loaded);
    }

    _loaded(data)
    {
        if (data.error)
            //this.event("server-error", data);
            this.event("load-texts-error", data);
        else
        {
            if (data.length > 0)
            {
                this.addItem(data, false);
                this._cache[data[0].theme_tag_id] = data;
            }
        }
    }

    use(id, use)
    {
        let text = super.find({id : id});
        if (text)
            text.number = use ? (text.number + 1) : (text.number - 1);
    }

    updateThumb(text, html)
    {
        var formData = new FormData();
        formData.append('id', text.id);
        formData.append('id_lang', text.id_lang );
        formData.append('content', text.content);
        formData.append('html', html);
        formData.append('platform', "desktop");
        formData.append('mediatype', 'text');
        formData.append('width', text.text_width );
        formData.append('height', text.text_height );
        formData.append('theme_tag_id', text.theme_tag_id );
        
        this.post('/app/config/upload', formData, this._thumbSaved , {processData: false,  contentType: false, timeout : 0 } );

    }

    _thumbSaved(data)
    {
        if (data.error)
        {
            //this.event("server-error", data);
            this.event("save-text_thumb-error", data);
        }
        else
        {
            let text = this.find({id : data.id, id_lang : data.id_lang});
            text.thumb = data.thumb;
            text.event("text-thumb-saved");
        }
        
    }

    loadRecommended( theme_id )
    {
        this.post({ action : "recommended", theme_id :  theme_id}, this._loadedRecommandedHandler);
    }

    _loadedRecommended(data)
    {
        this.addItem( data, true, false, false, true );

        this.trigger("loaded");
    }

});